// BNESS-32455 — Inner preview iframe is sandboxed with `sandbox="allow-scripts …"`.
// Attacker-controlled email HTML runs in an opaque origin and cannot reach parent
// cookies, JWT, or DOM. All parent<->preview communication uses postMessage.
//
// Message vocabulary (all JSON-encoded strings on evt.data):
//   parent → outer loader: { type: 'set-preview-html', html }
//   inner iframe → outer loader → parent: { type: 'preview-content-changed', height }
//   outer loader → parent: { type: 'preview-iframe-loaded' } (broadcast on ready)
//
// Source validation (BNESS-32455 hardening):
//   - set-preview-html is accepted ONLY if evt.source === window.parent.
//   - Relayed messages from the inner iframe are accepted ONLY if
//     evt.source === innerIframe.contentWindow.
//   This prevents an attacker frame from either (a) injecting arbitrary HTML
//   into the preview or (b) spoofing height / click reports to the parent.
export const previewLoaderHtml = `
<!DOCTYPE html>
<html lang="en">
<head>
    <style>
        * { box-sizing: border-box; }
        html, body { padding: 0; margin: 0; height: 100%; overflow-y: hidden; }
        body { margin: 8px; height: 100%; }
        #preview-content { border: 0; overflow: hidden; width: 100%; height: 100%; }
    </style>
    <script>
        var innerIframe = null

        function relayToParent(data) {
            try { window.parent.postMessage(JSON.stringify(data), '*') } catch (e) {}
        }

        window.addEventListener('message', function (evt) {
            var data
            try { data = typeof evt.data === 'string' ? JSON.parse(evt.data) : evt.data } catch (e) { return }
            if (!data || typeof data !== 'object') return

            // Parent → outer loader: install sanitized email HTML into the sandboxed inner iframe.
            // Reject any set-preview-html message that did not come from our own parent window.
            if (data.type === 'set-preview-html') {
                if (evt.source !== window.parent) return
                if (!innerIframe) innerIframe = document.getElementById('preview-content')
                if (!innerIframe) return
                innerIframe.srcdoc = data.html
                return
            }

            // Inner iframe reports height — forward upstream to the React app.
            // Reject height reports that did not originate inside our own inner iframe.
            if (data.type === 'preview-content-changed') {
                if (!innerIframe || evt.source !== innerIframe.contentWindow) return
                relayToParent(data)
            }
        })

        window.addEventListener('DOMContentLoaded', function () {
            innerIframe = document.getElementById('preview-content')
            relayToParent({ type: 'preview-iframe-loaded' })
        })
    </script>
</head>
<body>
<iframe
    id="preview-content"
    sandbox="allow-scripts allow-popups allow-popups-to-escape-sandbox"
    referrerpolicy="no-referrer"
    srcdoc="<html><body></body></html>"
></iframe>
</body>
</html>
`
